import typeToReducer from 'type-to-reducer';

import * as actions from "../actions";

const iniState = {
  loading: false,
  success: false,
  error: false,
  paymentReference: null,
  duplicate: null
}

export const payment = typeToReducer({
  [actions.SUBMIT_APPLICATION_DATA]: {
    PENDING: (state) => ({
      ...state,
      loading: true,
      success: false,
      error: false,
    }),
    REJECTED: (state, action) => ({
      ...state,
      loading: false,
      success: false,
      error: action.payload.data,
    }),
    FULFILLED: (state) => ({
      ...state,
      loading: false,
      success: true,
      error: false,
    })
  },
  [actions.MAKE_CPP_PAYMENT]: {
    PENDING: (state) => ({
      ...state,
      loading: true,
      success: false,
      error: false,
      paymentReference: null,
      duplicate: null,
    }),
    REJECTED: (state, action) => ({
      ...state,
      loading: false,
      success: false,
      error: action.payload && action.payload.response && action.payload.response.data,
      paymentReference: null,
      duplicate: null,
    }),
    FULFILLED: (state, action) => ({
      ...state,
      loading: false,
      success: true,
      error: false,
      paymentReference: null,
      duplicate: null,
      ...action.payload.data,
    })
  },
  [actions.INIT_PAYMENT]: {
    PENDING: (state) => ({
      ...state,
      loading: true,
      success: false,
      error: false,
      paymentReference: null,
      duplicate: null,
    }),
    REJECTED: (state, action) => ({
      ...state,
      loading: false,
      success: false,
      error: action.payload && action.payload.response && action.payload.response.data,
      paymentReference: null,
      duplicate: null,
    }),
    FULFILLED: (state, action) => ({
      ...state,
      loading: false,
      success: true,
      error: false,
      paymentReference: null,
      duplicate: null,
      ...action.payload.data,
    })
  },
  [actions.CLEAR_FORM]: () => ({
    ...iniState
  })
}, iniState);
